module.exports = __webpack_public_path__ + "img/1467395849.05460c95.jpg";